import { Alert, AlertProps, Box } from '@amzn/awsui-components-react';
import { useState } from 'react';

import { constants } from '../../common/Localization';
import FeedbackDropdown from '../common/FeedbackDropdown';

type PreviewProps = {
    customText?: React.ReactNode;
    customHeader?: string;
    additionalInfo?: string;
    alertType?: AlertProps.Type;
}

function PreviewBanner({ customText, customHeader, additionalInfo, alertType = 'info' }: PreviewProps): JSX.Element | null {
    
    const [visible, setVisible] = useState(true);
   
    const content = customText || additionalInfo ? (
        <div>
            {customText ? (<span>{customText}</span>) : null}
            {additionalInfo ? (<p>{additionalInfo}</p>) : null}
        </div>
    ) : null;

    return (
        <Box padding={ visible ? {vertical: 'l'} : {}}>
            <Alert 
                header={customHeader ?? constants.PREVIEW_THIS_IS_A_PREVIEW_FEATURE}
                action={<FeedbackDropdown buttonText={constants.TELL_US_WHAT_YOU_THINK} /> }
                type={alertType} 
                visible={visible} 
                dismissible 
                onDismiss={() => setVisible(false)}
            >
                {content}
            </Alert>
        </Box>
    );
}

export default PreviewBanner;
